import Card from "@components/ui-components/card";
import CommonModal from "@components/ui-components/modal";
import { Conditions } from "../upsert/conditions";
import Flex from "@src/@core/components/ui-components/flex";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import LoadingButton from "@components/ui-components/loading-button";
import PaginationDataTable from "@components/datatable";
import size from "lodash/size";
import useGoals from "./use-goals";

const Goals = props => {
    const { goals } = props;
    const {
        loading,
        columns,
        methods,
        isDirty,
        updateLoading,
        handleModal,
        onSubmit,
        isOpen,
        handleRowActions
    } = useGoals(props);

    const {
        control,
        watch,
        formState: { errors }
    } = methods;

    const isEdit = watch("action") !== "add";

    const content = [
        {
            leftChild: {
                title: "Goal Name"
            },
            rightChild: (
                <InputField
                    label="Goal Name"
                    required
                    errors={errors}
                    id="name"
                    name="name"
                    control={control}/>
            )
        },
        {
            leftChild: {
                title: "Condition"
            },
            rightChild: (
                <Conditions type="goal" methods={methods} name="conditions" />
            )
        }
    ];

    return (
        <>
            <Card
                header={
                    <Flex justify="between" className="w-100 border-bottom pb-1" align="center">
                        <h4 className="mb-0">
                            {"Total Goals"}: &nbsp;{size(goals)}
                        </h4>
                        <LoadingButton
                            text="Add Goal"
                            icon="plus"
                            onClick={() => handleRowActions({}, "add")}
                            subject="life-cycle"/>
                    </Flex>
                }>
                <PaginationDataTable
                    dense
                    loading={loading}
                    defaultLimit={5}
                    data={goals}
                    columns={columns}/>
            </Card>

            <CommonModal
                title={`${isEdit ? "Edit" : "Add"} Goals`}
                body={<FormView content={content} />}
                confirmButton={{
                    txt    : isEdit ? "Update" : "Add",
                    icon   : "content-save",
                    onClick: onSubmit,
                    loading: updateLoading
                }}
                type="extraLarge"
                isDirty={isDirty}
                loading={loading}
                handleModal={handleModal}
                isOpen={isOpen}/>
        </>
    );
};

export default Goals;
